import { Component, inject } from '@angular/core';
import { LoadingService } from '../../core/services/app-loading.service';

@Component({
  selector: 'app-spinner',
  standalone: true,
  imports: [],
  templateUrl: './spinner.html',
  styleUrl: './spinner.scss',
})
export class Spinner {
  readonly loadingService = inject(LoadingService);
}
